import {CtModelRouteData} from "@ctsolution/ct-framework";

export const FormTemplateRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("FormTemplate");
